import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 321,
      sm: 600,
      md: 1024,
      lg: 1441,
    },
  },
  theme: {
    themes: {
      light: {
        primary: "#762C58",
        secondary: "#066C7E",
        tertiary: "#053C5E",
        quadrangle: "#1f7a8c",
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
});

// "xs": 0,
// "sm": 340px,
// "md": 540px,
// "lg": 800px - 24px,
// "xl": 1280px - 24px,
